import { MutationHookOptions, gql, useMutation } from '@apollo/client';
import { useMemo } from 'react';
import { DeleteSavedRowResponse, DeleteSavedRowVariables } from '../types';

export type DeleteSavedRowOptions = MutationHookOptions<
  DeleteSavedRowResponse,
  DeleteSavedRowVariables
>;

const deleteSavedRowMutation = gql`
  mutation DeleteBeeRow($rowId: Long!) {
    deleteBeeRow(beeRowId: $rowId) {
      beeRowMetadataId
      beeRowName
      failure {
        ... on BeeSavedRowDeletionFailure {
          errorMsg
        }
      }
    }
  }
`;

export const useDeleteSavedRowMutation = (options?: DeleteSavedRowOptions) => {
  const mutationOptions: DeleteSavedRowOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      ...options,
    }),
    [options],
  );

  const [deleteSavedRow, { data, loading }] = useMutation<
    DeleteSavedRowResponse,
    DeleteSavedRowVariables
  >(deleteSavedRowMutation, mutationOptions);

  return {
    failure: data?.deleteBeeRow.failure || null,
    isDeletingSavedRow: loading,
    deleteSavedRow,
  };
};
